const categories = [
    "Menu Pembuka",
    "Menu Utama",
    "Menu Penutup"
];

export default categories;